import { render, staticRenderFns } from "./professionalTax.vue?vue&type=template&id=4c772cea&scoped=true&lang=html"
import script from "./professionalTax.vue?vue&type=script&lang=js"
export * from "./professionalTax.vue?vue&type=script&lang=js"
import style0 from "./professionalTax.vue?vue&type=style&index=0&id=4c772cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c772cea",
  null
  
)

export default component.exports